/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { DelegationRoles } from '@constants/user';
import { getUserNameList } from '@features/survey-question-list/utils';
import { Column } from '@g17eco/molecules/tracking-list';
import { SurveyDelegationUser } from '@g17eco/types/user';

interface ColumnContributorsProps extends ColumnCommonProps {
  users?: SurveyDelegationUser[];
}

export const ColumnContributors = (props: ColumnContributorsProps) => {
  const { question, handleGoToQuestion, users } = props;

  const userList = getUserNameList({
    users,
    delegationUserIds: question.utrv?.stakeholders.stakeholder,
    // Only show users with inititiave role, as other must be based on utrv
    check: (u) => u.delegationRoles.includes(DelegationRoles.InitiativeStakeholder),
  });

  return (
    <Column className='pl-2 stakeholderCol' truncateTwoline onClick={handleGoToQuestion}>
      <strong>Contributors:</strong>  {userList.join(', ') || 'none'}
    </Column>
  );
}
